import { getShiftClockedInDurationInHours } from "@src/appV2/redesign/utils/getShiftClockedInDuration";

import { type TimesheetEntry } from "../hooks/useTimesheetEntry";

/**
 * Calculates total paid hours for a timesheet entry, subtracting any break duration.
 * Returns 0 when clock-in/out are identical or the result would be negative.
 */
export function calculateTimesheetWorkedHours(timesheet: TimesheetEntry): number {
  const clockInOut = {
    start: timesheet.clockInTime.toISOString(),
    end: timesheet.clockOutTime.toISOString(),
  };

  const lunchInOut =
    timesheet.breakStartTime && timesheet.breakEndTime
      ? {
          start: timesheet.breakStartTime.toISOString(),
          end: timesheet.breakEndTime.toISOString(),
        }
      : undefined;

  return getShiftClockedInDurationInHours(clockInOut, lunchInOut) ?? 0;
}
